import React, { useState } from 'react';
import SimpleReactLightbox from 'simple-react-lightbox';
import { SRLWrapper } from 'simple-react-lightbox';
import { Nav, Panel } from 'rsuite';
import { Container, Row, Col, Card } from 'react-bootstrap'
import { dela } from "./dela";
import { v4 as uuidv4 } from 'uuid';
import "rsuite/dist/rsuite.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";

function shuffle(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}

function App() {
  const [active, setActive] = useState("pionirji-foto");

  const options = {
    buttons: {
      showDownloadButton: false,
    },
  };

  return (
    
      <div className="App">
        <Container>
          <h1>SPLETNA LIKOVNO-FOTOGRAFSKA RAZSTAVA 2023</h1>
          <div style={{display: "flex", justifyContent: "center"}}>
            <Card
              bg="light"
              style={{ width: '75%'}}
              className="mb-2"
            >
              <Card.Body>
                <Card.Title>Dobrodošli na spletni razstavi!</Card.Title>
                <Card.Text>
                  Na tej strani je na ogled na voljo spletna razstava fotografskih del, ki jih je pripravila gasilska mladina prostovoljnih gasilskih društev Gasilske zveze Ljubljana.<br /><br />
                  {/* Razstava likovnih in fotografskih del je potekala od 7. 11. 2022 do 13. 11. 2022 v Meršolovem atriju Zavoda sv. Stanislava.<br /><br /> */}
                  Razstave poteka na temo <b>Požar v naravi</b>
                </Card.Text>
              </Card.Body>
            </Card>
          </div>
        </Container>
        <div className="navigation">
          <Container>
            <Nav appearance="subtle" activeKey={active} onSelect={setActive} justified>
              <Nav.Item eventKey="pionirji-foto">Pionirji - fotografska dela</Nav.Item>
              <Nav.Item eventKey="mladinci-foto">Mladinci - fotografska dela</Nav.Item>
              <Nav.Item eventKey="pripravniki-foto">Pripravniki - fotografska dela</Nav.Item>
            </Nav>
          </Container>
        </div>
        {active === "pionirji-foto" &&
          <SimpleReactLightbox>
            <Container>
              <SRLWrapper options={options}>
                <Row>
                  {shuffle(dela).map((e, index) => {
                    return (
                      e.kategorija === "pionirji" &&
                        <Col key={uuidv4()}>
                          <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240, marginBottom: "1rem" }}>
                            <div>
                              <a href={`images/${e.file_name}.jpg`} >
                                <img src={`images/thumbnails/${e.file_name}.jpg`} width="100%" alt={`Avtor: ${e.avtor_name}, ${e.drustvo}, ${e.starost}`} />
                              </a>
                            </div>
                            <Panel header={`Avtor: ${e.avtor_name}`}>
                              <p>
                                {e.drustvo}<br />
                                Starost: {e.starost} let
                              </p>
                            </Panel>
                          </Panel>
                        </Col>)
                  })}
                  </Row>
                </SRLWrapper>
            </Container>
          </SimpleReactLightbox>
        }
        {active === "mladinci-foto" &&
          <SimpleReactLightbox>
            <Container>
              <SRLWrapper options={options}>
                <Row>
                  {shuffle(dela).map((e, index) => {
                    return (
                      e.kategorija === "mladinci" &&
                        <Col key={uuidv4()}>
                          <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240, marginBottom: "1rem" }}>
                            <div>
                              <a href={`images/${e.file_name}.jpg`} >
                                <img src={`images/thumbnails/${e.file_name}.jpg`} width="100%" alt={`Avtor: ${e.avtor_name}, ${e.drustvo}, ${e.starost}`} />
                              </a>
                            </div>
                            <Panel header={`Avtor: ${e.avtor_name}`}>
                              <p>
                                {e.drustvo}<br />
                                Starost: {e.starost} let
                              </p>
                            </Panel>
                          </Panel>
                        </Col>)
                  })}
                  </Row>
                </SRLWrapper>
            </Container>
          </SimpleReactLightbox>
        }
        {active === "pripravniki-foto" &&
          <SimpleReactLightbox>
            <Container>
              <SRLWrapper options={options}>
                <Row>
                  {shuffle(dela).map((e, index) => {
                    return (
                      e.kategorija === "pripravniki" &&
                        <Col key={uuidv4()}>
                          <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240, marginBottom: "1rem" }}>
                            <div>
                              <a href={`images/${e.file_name}.jpg`} >
                                <img src={`images/thumbnails/${e.file_name}.jpg`} width="100%" alt={`Avtor: ${e.avtor_name}, ${e.drustvo}, ${e.starost}`} />
                              </a>
                            </div>
                            <Panel header={`Avtor: ${e.avtor_name}`}>
                              <p>
                                {e.drustvo}<br />
                                Starost: {e.starost} let
                              </p>
                            </Panel>
                          </Panel>
                        </Col>)
                  })}
                  </Row>
                </SRLWrapper>
            </Container>
          </SimpleReactLightbox>
        }
        <footer>
          <Container>
            <p>2023 - Gasilska zveza Ljubljana - Komisija za mladino</p>
          </Container>
        </footer>
      </div>
  );
}

export default App;
